import {CityDTO} from 'grilnica-share'

const getSiteUrlByCity = (city: CityDTO): string => {
  const url = new URL(city.siteUrl)
  return url.toString()
}

export {getSiteUrlByCity}
